export default function Loading() {
  return (
    <div className="container mx-auto my-20 text-center">
      <i className="fas fa-spin fa-spinner fa-2x" />
    </div>
  );
}
